'use client'

import type { ArticleTeaserProps } from '@maestro/commerce-blocks/components/article-teaser/article-teaser.types'

import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer'

export function useArticleTeaser(props: ArticleTeaserProps) {
  const t = useTranslations('commerce-blocks')
  const { publish } = useEventBusContext()

  const onReadMoreClick = useCallback(() => {
    publish(EventType.CTA_CLICKED, {
      location: 'article',
      click_text: `${t('_globals.read-more')}`,
      click_url: props.url,
    })
  }, [publish, t, props.url])

  return { onReadMoreClick }
}
